import { NgModule } from '@angular/core';
import { MailshotComponent } from './mailshot/mailshot.component';
import { MailshotRoutingModule } from './mailshot-routing.module';
import { MailshotStaticComponent } from './mailshot static/mailshot-static.component';
import { AppCommonModule } from '@app/components/app.common.module';
import { ModalMailshotComponent } from './modal-mailshot/modal-mailshot.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailsMailshotComponent } from './details-mailshot/details-mailshot.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    MailshotComponent,
    MailshotStaticComponent,
    ModalMailshotComponent,
    DetailsMailshotComponent,
  ],
  imports: [
    AppCommonModule,
    CommonModule,
    MailshotRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class MailshotModule {}
